import { Flex } from 'antd'
import styled from 'styled-components'

export const LogsSection = styled(Flex)``

export const Content = styled(Flex)``

export const TaskLogsStats = styled(Flex)``

export const LogsTable = styled.div`
  height: 328px;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.divider};
  overflow: hidden;
`

export const LogsLoading = styled(Flex)`
  height: 100%;
  padding: 16px;
`
